module.exports = __webpack_public_path__ + "files/9d4e07ed88f7717a76fa9539ac36ee75.png";